import React from "react";

const JetstarAir = () => {
  return <div>JetstarAir</div>;
};

export default JetstarAir;
